import React from 'react';

import Icon from 'components/Icon';
import Link from 'components/Link';
import Logo from 'components/Logo';

import styles from './Header.module.scss';

interface HeaderProps {
  onBack?: () => void;
  percentComplete: number;
}

export const Header: React.FC<HeaderProps> = ({ onBack, percentComplete }) => {
  return (
    <div className={styles.header}>
      <Link href={'https://huzzle.app'}>
        <Logo
          name="huzzle-new"
          size="small"
          color="black"
          className={styles.logo}
        />
      </Link>
      <section className={styles.progress}>
        {onBack && (
          <div onClick={onBack} className={styles.backButton}>
            <Icon iconName={'arrow-button-left'} />
          </div>
        )}
        <div className={styles.progressContainer}>
          <div
            className={styles.progressContainerFill}
            style={{ width: `${percentComplete}%` }}
          />
        </div>
      </section>
    </div>
  );
};
